import { Tooltip } from 'antd';
import { TooltipPlacement } from 'antd/lib/tooltip';
import React from 'react';
import { FaHotel } from 'react-icons/fa';
import HotelDescriptionTooltip from './HotelDescriptionTooltip/HotelDescriptionTooltip';
import { TenantTsType } from '../../constants/tenantTs';
import { SkyInventoryBadge } from '../sky-inventory-badge/SkyInventoryBadge';
import './hotel-element.less';

export interface HotelElementProps {
  tooltipPlacement?: TooltipPlacement;
  address: string;
  country: { name: string };
  identifier: string;
  image: string[];
  name: string;
  type: 'Hotel';
  stars: number;
  distance?: number;
  ts_type?: TenantTsType;
  skyInventoryLabel?: string;
}

export const HotelElement = ({
  tooltipPlacement = 'left',
  skyInventoryLabel,
  ...props
}: HotelElementProps) => {

  const isSkyInventory = props?.ts_type === TenantTsType.SKY;

  return (
    <div className={`auto-complete-hotel-element${isSkyInventory ? ' is-sky-inventory' : ''}`}>
      <div
        className="type-icon-wrapper"
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 5,
        }}
      >
        <FaHotel size={24} />
        {props?.distance && (
          <span className="distance">
            <b>{props.distance.toFixed(2)}</b> km
          </span>
        )}
      </div>
      <Tooltip
        color={'#fff'}
        placement={tooltipPlacement}
        align={{ offset: [-30, 0] }}
        overlayClassName={'hotel-description-tooltip'}
        title={<HotelDescriptionTooltip {...props} />}
      >
        <div className="element-info-wrapper">
          <span className="name">
            {props?.name}
            {isSkyInventory && skyInventoryLabel && (
              <SkyInventoryBadge label={skyInventoryLabel} variant="inline" />
            )}
          </span>
          <span className="description">{`${props?.country?.name}, ${props?.address}`}</span>
        </div>
      </Tooltip>
    </div>
  );
};
